module.exports = __webpack_public_path__ + "img/4.02923e8d.jpg";